module.exports = __webpack_public_path__ + "img/icon-vector-copy.0de2f13.svg";